/**
 * Summary. Promotions Logic
 *
 * Description.
 * 1. Checks to see if cart form is on the page, if it is, it creates a new instance of Promotion and passes through the form
 * 2. Constructor to set up variables and to kickstart the bindings and inital functions
 * 3. Handle Form submit, pass the note and code to checkout if there is one else just go to the checkout
 * 4. Add upsell if threshold is met, listen for changes in cart total and remove if below threshold
 * 5. Listeners for cart total and cart item number changes
 * 6. Get products from schema for free gift and return them with null and undefined stripped out
 * 7. Auto free gift if threshold met, works from highest to lowest to apply the correct ones and listens for gift type, tiered or stacked
 * 8. Add gift, checks code entered against ones antered in the back end from comma sepeartaed list, built in static-cart-gift-with-purchase.liquid
 * 9. Global add and remove functions using axios to pass mutliple items to the cart
 * 10. Remove gift, check to see if the cart total is less than the min spend
 */
class PromotionsController {
  constructor() {
    const elements = document.querySelectorAll('.js-cart-form');
    // Check to see if the the cart form is on the page if it is invoke a new instance of Promotion class
    if (elements.length > 0) {
      elements.forEach(element => new Promotion(element));
    }
  }
}

class Promotion {
	constructor(element) {
		// General selectors
		this.element = element;

		this.localCurrency = this.element.querySelector('[data-local-currency]');

		this.cartObject = document.querySelector('.js-cart-form');

		// Promo code selectors
		this.promoBtn = document.querySelector('#gwp-influencer-submit');
		console.log('this.promoBtn')
		console.log(this.promoBtn)
		this.applyPromo = document.querySelector('#gwp-influencer-submit');
		this.promoDifference = this.element.querySelector('#promo-difference');
		this.promoApplied = this.element.querySelector('#promo-applied');
		this.promoError = this.element.querySelector('#promo-error');
		this.freeGift = this.element.querySelectorAll('[data-free-gift]');

		// Upsell selectors
		this.sampleItem = this.element.querySelector('.sample-item');
		this.sampleItems = this.element.querySelectorAll('.sample-item');
		this.cartItemTotal = document.querySelector('.cart-count-bubble > span');
		this.productUpsell = this.element.querySelector(
			'.collection-product--upsell'
		);
		this.productUpsellOption = document.querySelectorAll(
			'.productitem--action-atc'
		);
		this.sampleItemsId = '';
		this.productUpsellThresholdLimit = [];
		this.productUpsellLimit = [];
		this.productUpsellThreshold = [];
		this.currentUpsellLimit = '';
		this.currentUpsellThreshold = '';
		this.upSellDifference = this.element.querySelector(
			'.collection-product--upsell-spend'
		);
		this.upSellDifferenceTotal = document.querySelector(
			'.collection-product--upsell-spend .upsell-difference span'
		);
		this.cart = document.querySelector('.cart-subtotal .money');
		this.cartTotal = '';
		this.flkty = '';
		this.options = {
			cellAlign: 'left',
			pageDots: false,
			wrapAround: true,
			on: {
				ready: function () {
					this.element.classList.add('flickity-ready')
				}
			}
		};

		this.onLoad();
		this.upsellCarousel();
		this.addUpsell();
	}

	onLoad() {
		if (!this.cart) {
			return;
		}

		this.cartTotal = document.querySelector(
			'.cart-subtotal .money'
		).dataset.cartTotal;

		this.productUpsellThresholdLimit = this.productUpsellThresholdLimit.sort(
			(a, b) => b[0] - a[0]
		);

		if (this.productUpsell) {
			this.sampleItemsId = this.productUpsell.querySelectorAll('[data-id]');

			for (let i = 0; i < this.productUpsellThresholdLimit.length; i++) {
				let threshold = parseInt(this.productUpsellThresholdLimit[i][0]);
				let limit = parseInt(this.productUpsellThresholdLimit[i][1]);

				this.productUpsellThreshold.push(threshold);
				this.productUpsellLimit.push(limit);
			}

			for (let i = 0; i < this.productUpsellThresholdLimit.length; i++) {
				let threshold = parseInt(this.productUpsellThresholdLimit[i][0]);
				let limit = parseInt(this.productUpsellThresholdLimit[i][1]);

				if (parseInt(this.cartTotal) >= threshold * 100) {
					this.currentUpsellLimit = limit;
					this.currentUpsellThreshold = threshold;
					this.productUpsell.dataset.currentUpsellLimit = limit;
					this.productUpsell.dataset.currentUpsellThreshold = threshold;

					break;
				}
			}
		}
	}

	async bindEvents() {
		const cartState = await Shopify.theme.cart.getState();

		if (this.cartObject) {
			this.cartObject.classList.remove('disable-checkout');
		}

		if (cartState.items.length === 0) return;

		// Form submit
		this.element.addEventListener(
			'submit',
			this.handleFormSubmit.bind(this),
			false
		);
		// Promo button click
		this.promoBtn.addEventListener('click', this.addGift.bind(this), false);

		// listen for upsell add
		this.productUpsellOption.forEach((element) => {
			element.addEventListener('click', (e) => {
				this.cartObject.classList.add('disable-checkout');

				const id = parseInt(e.currentTarget.getAttribute('data-variant-id'));

				const URL = '/cart/add.js';
				const options = {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
				};

				fetch(URL, options)
					.then((res) => {
						window.location.reload(true);
					})
					.catch((err) => {
						this.cartObject.classList.remove('disable-checkout');
						console.log(err);
					});
			});
		});

		const cartTotalItemsObserver = new MutationObserver(
			this.cartTotalItemsCallback.bind(this)
		);
		cartTotalItemsObserver.observe(this.cartItemTotal, {
			attributes: true,
			childList: true,
			subtree: true,
		});

		// listen for cart value changes
		const cartTotalObserver = new MutationObserver(
			this.cartTotalCallback.bind(this)
		);
		cartTotalObserver.observe(this.cartItemTotal, {
			attributes: true,
			childList: true,
			subtree: true,
		});

	}

	handleFormSubmit(event) {
		event.preventDefault();

		const code = this.element
			.querySelector('[data-cart-discount-code]')
			.value.toUpperCase();
		const note = this.element.querySelector('.js-cart-note').value;

	}

	async addUpsell() {
		const cartState = await Shopify.theme.cart.getState();
		const samplesInCart = cartState.items.filter(
			(item) => item.product_type === 'sample'
		);

		if (!this.productUpsellOption || !this.productUpsell) {
			return;
		}

		if (
			this.cartTotal >= this.currentUpsellThreshold &&
			this.currentUpsellLimit !== samplesInCart.length
		) {
			let flkty = Flickity.data('.productgrid--items');
			this.productUpsell.classList.remove('hide--upsell');
			this.upSellDifference.classList.remove('hide--upsell');

			if (flkty) {
				flkty.resize();
			}
		}

		if (this.productUpsellLimit[0] == this.currentUpsellLimit) {
			this.upSellDifference.classList.add('hide--upsell');
		}

		// Add class to products in sample selector that have already been added to cart
		samplesInCart.filter((sample) => {
			this.sampleItemsId.forEach((item) => {
				if (parseInt(item.dataset.id) === parseInt(sample.product_id)) {
					item.classList.add('sample-in-cart');
				}
			});
		});

		// Show samples if they are in cart
		for (const sample of this.sampleItems)
			sample.classList.remove('hide--upsell');
	}

	upsellCarousel() {
		this.flkty = new Flickity(
			document.querySelector('.productgrid--items'),
			this.options
		);
	}

	// listen for item number changes
	cartTotalItemsCallback(mutationsList, cartTotalItemsObserver) {
		this.cartItemTotal = document.querySelector('.site-header-cart--count');
		this.sampleItem = document.querySelector('.sample-item');

		for (let mutation of mutationsList) {
			if (mutation.type === 'attributes') {
				if (this.cartItemTotal.dataset.headerCartCount < 1) {
					this.productUpsell.classList.add('hide--upsell');
					this.upSellDifference.classList.remove('hide--upsell');
				}

				if (parseInt(this.cartTotal) > parseInt(this.productUpsellThreshold)) {
					if (
						!this.sampleItem ||
						this.sampleItem.classList.contains('removing')
					) {
						this.productUpsell.classList.remove('hide--upsell');
						this.upSellDifference.classList.add('hide--upsell');
					}
				}
			}
		}
	}

	async cartTotalCallback(mutationsList, cartTotalObserver) {
		this.freeGift = document.querySelectorAll('.cart-item[data-free-gift]');
		this.threshold = parseInt(this.productUpsellThreshold);
		this.cartUpdated = false;

		for (let mutation of mutationsList) {
			if (mutation.type === 'attributes') {
				this.cartObject.classList.add('disable-checkout');
				if (this.cartTotal < this.threshold) {
					this.productUpsell.classList.add('hide--upsell');
					this.upSellDifference.classList.remove('hide--upsell');

					// work out the new difference and tell the customer
					this.newDifference =
						parseInt(this.productUpsellThreshold) - parseInt(this.cartTotal);
					this.upSellDifferenceTotal.innerHTML = Shopify.formatMoney(
						this.newDifference,
						this.localCurrency.dataset.localCurrency
					);

					if (this.sampleItem) {
						this.sampleItem.classList.add('hide--upsell');
						this.cartObject.classList.add('disable-checkout');
						this.cartUpdated = true;
					}
				}

				if (this.cartTotal > this.threshold) {
					if (!this.sampleItem) {
						this.productUpsell.classList.remove('hide--upsell');
						this.upSellDifference.classList.add('hide--upsell');
					}
				}

				if (this.cartTotal === 0) {
					if (this.freeGift) {
						this.cartObject.classList.add('disable-checkout');
						this.cartUpdated = true;
					}
				}

				this.cartUpdated = true;
			}
		}

		if (this.cartUpdated) window.location.reload(true);
	}

	async autoFreeGift() {
		const cartState = await Shopify.theme.cart.getState();
		const cartTotal =
			cartState.items.reduce((total, { line_price, properties }) => {
				return Object.keys(properties).find((key) =>
					key.startsWith('_threshold-')
				)
					? total - line_price
					: total;
			}, cartState.total_price) / 100;

		// Quick fix to force 0 priced items to display as 0 in the basket
		// This can probably be done in a better way
		const lineItemPriceArr = document.querySelectorAll('[data-cartitem-total]');

		lineItemPriceArr.forEach((item) => {
			if (item.dataset.cartitemTotal == 0) {
				item.innerHTML = item.innerHTML.replace(/[^$£€]*$/, '0.00');
			}
		});

		let thresholdSet = new Set();
		// This reducer returns an object which contains an add and remove array of variant IDs so that we can bulk add/remove at the end
		const updates = this.autoFreeGiftThresholds.reduce(
			(allUpdates, { amount, variantIds }) => {
				// Check if the total is greater than the threshold and we're either in a stacked promotion or haven't applied a tier yet
				// if so add any items that aren't already in the cart to the add array
				variantIds.filter((id) =>
					cartState.items.find(({ variant_id, properties }) => {
						if (id === variant_id && properties[`_threshold-${amount}-${id}`]) {
							thresholdSet.add(
								parseInt(
									Object.keys(properties)
										.find((key) => key.startsWith('_free-'))
										.replace('_free-', '')
								)
							);
						}
					})
				);

				let thresholds = Array.from(thresholdSet);

				if (
					cartTotal >= parseInt(amount) &&
					(this.autoFreeGiftTypeStacked || !allUpdates.tierApplied)
				) {
					allUpdates.add.push(
						...variantIds
							.filter(
								(id) =>
									!cartState.items.find(
										({ variant_id, properties }) =>
											id === variant_id &&
											properties[`_threshold-${amount}-${id}`]
									)
							)
							.map((id) => ({
								id,
								quantity: 1,
								properties: {
									[`_threshold-${amount}-${id}`]: 'true',
									[`_free-${amount}`]: 'true',
								},
							}))
					);
					allUpdates.tierApplied = true;
				}

				if (!this.autoFreeGiftTypeStacked) {
					if (thresholds.length > 1) {
						if (
							cartTotal > Math.min(...thresholds) &&
							amount !== Math.min(...thresholds)
						) {
							allUpdates.remove.push(
								...variantIds.filter((id) =>
									cartState.items.find(
										({ variant_id, properties }) =>
											id === variant_id &&
											properties[`_threshold-${Math.min(...thresholds)}-${id}`]
									)
								)
							);
						}
					}
				}

				// If we aren't in the threshold, add any items that are in the cart that are part of this promotion to the remove array
				if (cartTotal < parseInt(amount)) {
					allUpdates.remove.push(
						...variantIds.filter((id) =>
							cartState.items.find(
								({ variant_id, properties }) =>
									id === variant_id && properties[`_threshold-${amount}-${id}`]
							)
						)
					);
				}
				return allUpdates;
			},
			{ add: [], remove: [], tierApplied: false }
		);

		if (updates.add.length === 0 && updates.remove.length === 0) return; // Nothing to update in the cart, just return early

		if (updates.add.length) {
			this.cartObject.classList.add('disable-checkout');

			try {
				const URL = '/cart/add.js';
				const options = {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ items: updates.add }),
				};
				const res = await fetch(URL, options);
			} catch (err) {
				console.log(err);
			}
		}

		if (updates.remove.length) {
			this.cartObject.classList.add('disable-checkout');
			try {
				const URL = '/cart/update.js';
				const options = {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						updates: updates.remove.reduce(
							(updateObject, id) => ({ ...updateObject, [id]: 0 }),
							{}
						),
					}),
				};
				const res = await fetch(URL, options);
			} catch (err) {
				console.log(err);
			}
		}

		window.location.reload(true); // We've added/removed everything so reload to update the cart on page
	}

	// Gift With Purchase
	async addGift() {
		const cartState = await Shopify.theme.cart.getState();
		const cartTotal = cartState.total_price / 100;
		const code = this.element
			.querySelector('[data-cart-discount-code]')
			.value.toUpperCase();
		const codeHash = md5(code);
		const promotion = this.discountCodePromotions[codeHash];

		if (promotion) {
			if (cartTotal >= promotion.minimumSpend) {
				if (!this.allowStacking) {
					if (
						cartState.items.some(
							(item) =>
								item.properties.hasOwnProperty('promo') &&
								item.product_type === 'free gift'
						)
					) {
						return;
					}
				}

				this.applyPromo.classList.add('processing');

				const itemsToAdd = promotion.variantIds.reduce(
					(items, id) =>
						!cartState.items.find(({ variant_id }) => id === variant_id)
							? [
									...items,
									{
										id,
										quantity: 1,
										properties: {
											_discountPromotion: codeHash,
											promo: `FG-${code}`,
										},
									},
							  ]
							: items,
					[]
				);

				if (itemsToAdd.length) {
					this.msgStyles('none', 'block', 'none');
					try {
						const URL = '/cart/add.js';
						const options = {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
							},
							body: JSON.stringify({ items: itemsToAdd }),
						};
						const res = await fetch(URL, options);
					} catch (err) {
						console.log(err);
					}

					window.location.reload(true);
				}
			} else {
				this.promoText = this.element.querySelector(
					'#promo-difference span'
				).innerHTML = Shopify.formatMoney(
					promotion.minimumSpend * 100,
					this.localCurrency.dataset.localCurrency
				);
				this.promoDifference.querySelector('span').textContent = this.promoText;
				this.msgStyles('block', 'none', 'none');
			}
		} else {
			this.msgStyles('none', 'none', 'block');
		}

		this.applyPromo.classList.remove('processing');
	}

	msgStyles(diff, app, err) {
		this.promoDifference.style.display = diff;
		this.promoApplied.style.display = app;
		this.promoError.style.display = err;
	}

	async removeGift() {
		const cartState = await Shopify.theme.cart.getState();
		const cartTotal = cartState.total_price / 100;
		let sampleThreshold = '';
		let sampleLimit = '';
		const samplesInCart = [];

		if (this.productUpsell) {
			sampleThreshold = parseInt(
				this.productUpsell.dataset.currentUpsellThreshold
			);
			sampleLimit = parseInt(this.productUpsell.dataset.currentUpsellLimit);
		}

		cartState.items.forEach((item) => {
			if (item.product_type === 'sample') samplesInCart.push(item);
		});

		const updates = cartState.items.reduce(
			(payload, { properties, variant_id, product_type }) => {
				// if sample and number of samples is higher than sample limit or total price is less than sample limit
				if (
					product_type === 'sample' &&
					(cartTotal < sampleThreshold || samplesInCart.length > sampleLimit)
				)
					return { ...payload, [variant_id]: 0 };

				if (!properties._discountPromotion) return payload;

				const promotion =
					this.discountCodePromotions[properties._discountPromotion];

				if (!promotion || cartTotal < promotion.minimumSpend)
					return { ...payload, [variant_id]: 0 };
				return payload;
			},
			{}
		);

		if (Object.keys(updates).length === 0) return;

		this.cartObject.classList.add('disable-checkout');

		try {
			const URL = '/cart/update.js';
			const options = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ updates }),
			};
			const res = await fetch(URL, options);
		} catch (err) {
			console.log(err);
		}

		window.location.reload(true);
	}
}

window.addEventListener('load', function() {
  new PromotionsController();
});

// Event for Add to Cart
document.addEventListener('click', function (event) {

      const bagCounter = document.getElementsByClassName('site-header-cart--count');
      const itemCounter = bagCounter[0];
  if (!event.target.matches('.pcp-atc'))
    return;

  let variantsContainer = document.getElementById(event.target.getAttribute('data-handle'));
  let variants = variantsContainer.getElementsByClassName("pcp-variants");
  let variantID = event.target.getAttribute('data-variant');

  for (var i = 0; i < variants.length; i++) {
    if(variants[i].classList.contains('active')) {
      variantID = variants[i].getAttribute('data-variant');
    }
  }

  let formData;
  formData = {
    items: [{
      id: variantID,
      quantity: 1
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
  .then(response => {
    updateText(event);
    updateCartCount(event);
    return response.json();
  })
  .catch((error) => {
    if (error.status === 422) {
      console.log('Fail')
    }
  });

  function updateCartCount() {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then((response) => response.json())
    .then((object) => {
      itemCounter.classList.add('visible');
      itemCounter.setAttribute('data-header-cart-count',object.item_count);
      return object.item_count;
    })
    .catch((error) => {
      if (error.status === 422) {
        console.log('Fail')
      }
    });
  }

  function updateText(event) {
    let originalText = event.target.innerHTML;
    event.target.innerHTML = 'Added To Cart';
    setTimeout(function(){
      event.target.innerHTML = originalText;
    }, 3000);
  }
});


document.addEventListener('click', function (event) {
  if (!event.target.matches('.pcp-variants'))
    return;
    let container = document.getElementById(event.target.parentNode.getAttribute('id'));
    let variants = container.getElementsByClassName('pcp-variants');
    let price = event.target.getAttribute('data-price');
    let buttonSpan = document.getElementById(event.target.getAttribute('data-id')).getElementsByTagName('span')[0];


    for (var i = 0; i < variants.length; i++) {
      if(variants[i] == event.target) {
        variants[i].classList.add('active');
        buttonSpan.innerHTML = price;
      } else {
        variants[i].classList.remove('active');
      }
    }
});

document.addEventListener("DOMContentLoaded", function(event) {
    // Your code to run since DOM is loaded and ready

  const bnplWrapper = document.querySelector('.js-bnpl');
  if(!bnplWrapper) return;
  const bnplItems = bnplWrapper.querySelectorAll('.bnpl-item');
  if(!bnplItems) return;
  const bnplIconsWrapper = document.querySelector('.js-bnpl-icons');
  if(!bnplIconsWrapper) return;
  const bnplLogoItems = bnplIconsWrapper.querySelectorAll('.bnpl-logo-item');
  if(!bnplLogoItems) return;


    function handleButtonClick(event) {

        // 1. hide all button content
        bnplItems.forEach(item => {
            item.hidden = true;
        });
        // 2. mark all buttons as unselected
        bnplLogoItems.forEach(button => {
            button.setAttribute('aria-selected', false);
        });
        // 3. mark the clicked button as selected
        event.currentTarget.setAttribute('aria-selected', true);
        // 4. find the associated button content and show it
        const id = event.currentTarget.id;
        const buttonContent = bnplWrapper.querySelector(`[aria-labelledby="${id}"]`);
        buttonContent.hidden = false;
    }

    bnplLogoItems.forEach(button => button.addEventListener('click', handleButtonClick));

});

const cartShippingToggle = document.querySelector('.cart-shipping-toggle')
const cartShippingContent = document.querySelector('.cart-shippingcalc--container')
if (cartShippingToggle) {
  cartShippingToggle.addEventListener('click', () => {
    cartShippingContent.classList.toggle('is-active')
  })
}


